module.exports = global["origin"] = require("-!./origin.js");


//////////////////
// WEBPACK FOOTER
// ./dev/dcms_media/js/components/module/origin.js
// module id = 7
// module chunks = 0